import CardScore from '@/src/components/global/card-score/CardScore'
import { useTranslation } from 'react-i18next'
import { VpDivider } from '@vtmn-play/react/VpDivider'
import { VpIcon } from '@vtmn-play/react'

interface PriorityFamilySummaryProps {
  totalFamilies: number
  completedDiagnoses: number
  averageScore: number
}

const PriorityFamilySummary = ({
  totalFamilies,
  completedDiagnoses,
  averageScore,
}: PriorityFamilySummaryProps) => {
  const { t } = useTranslation('common')
  return (
    <div className="w-full flex py-3 border border-border-quiet">
      <div className="flex-1 flex flex-col justify-center items-center">
        <div className="flex gap-1 text-primary-blue">
          <VpIcon name="checkbox-multiple" />
          <span className="text-xl font-semibold">
            {completedDiagnoses}/{totalFamilies}
          </span>
        </div>
        <span>{t('components.priority-family-summary.finalized-diagnoses')}</span>
      </div>
      <VpDivider orientation="vertical" />
      <div className="flex-1 flex flex-col items-center justify-center">
        <CardScore score={averageScore} size="xl" scoreColored={true} />
        <span>{t('global.compliance')}</span>
      </div>
    </div>
  )
}

export default PriorityFamilySummary
